import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpSelectComponent } from './fcp-select.component';
import { FcpIconModule } from '../fcp-icon';
import { ClickOutsideDirective } from './click-outside.directive';

@NgModule({
    declarations: [FcpSelectComponent, ClickOutsideDirective],
    exports: [FcpSelectComponent],
    imports: [CommonModule, FcpIconModule]
})
export class FcpSelectModule {}
